import React from "react";
import { useSelector } from "react-redux";
import CoursesIncludedWithHigherSubscription from "./CoursesIncludedWithHigherSubscription";
import CoursesIncludedWithSubscription from "./CourseIncludedWithSubscription";

const CoursesWithSubscription = ({fetchData,is_home,from_sub}) => {

  const subscribedInfo = useSelector((state) => state.checkout.subscribedData);

  return (
    <>
      {subscribedInfo?.status === "success" ? (
        <CoursesIncludedWithSubscription
          fetchData={fetchData}
          currentSubscription={subscribedInfo?.payload?.data?.subscription_name}
          is_home={is_home}
          from_sub={from_sub}
        />
      ) : (
        <CoursesIncludedWithSubscription 
          fetchData={fetchData}
          is_home={is_home}
          from_sub={from_sub}
        />
      )}
    </>
  );
};

export default CoursesWithSubscription;
